'use client';

import { createContext, useContext, useEffect, useState } from 'react';

type Theme = 'normal' | 'darkside';

type ThemeContextType = {
  theme: Theme;
  toggleTheme: () => void;
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const [theme, setTheme] = useState<Theme>('normal');
  const [normalScrollPositionY, setNormalScrollPositionY] = useState<number>(0);

  const toggleTheme = () => {
    setTheme((prev) => {
      const newTheme = prev === 'normal' ? 'darkside' : 'normal';
      if (newTheme === 'darkside') {
        setNormalScrollPositionY(window.scrollY);
      }
      return newTheme;
    });
  };

  useEffect(() => {
    if (theme === 'normal') {
      window.scrollTo(0, normalScrollPositionY);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used inside ThemeProvider');
  }
  return context;
}
